var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879",
    transform: "translate(-1813 -45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(1813 45)",
    fill: "#f7f8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid",
    d: "M9.764,11.158A5.579,5.579,0,1,0,4.184,5.579,5.579,5.579,0,0,0,9.764,11.158ZM7.772,13.251A7.77,7.77,0,0,0,0,21.022a1.3,1.3,0,0,0,1.295,1.295H18.233a1.3,1.3,0,0,0,1.295-1.295,7.77,7.77,0,0,0-7.772-7.772Z",
    transform: "translate(1823.736 53.342)",
    fill: "#0f445a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2b6731f7342020fa93ec521d589abb6f.svg";
export { ForwardRef as ReactComponent };